export default {
  install(Vue) {
    Vue.prototype.zhugePoint = function (key, pms) {
      if (!key || key == '') return;
      try {
        const params = {
          eventTime: +new Date(),
          ...pms,
        };
        //vue诸葛埋点事件由于和问卷非同实例无法通知先屏蔽，全部迁移完成再打开
        // this.$EventBus.$emit('QUESTIONNAIRE_ZUGE_EVENT', {
        //   eventName: key,
        //   groupId: groupId || '',
        // });
        //通知上层vue诸葛埋点
        // this.$iframeMsg('VUE_ZHUGE_EVENT', {
        //   eventName: key,
        //   groupId: groupId || '',
        // });
        // if (process.env.NODE_ENV == 'development') {
        //   console.log('zhugePoint', key, params);
        //   return;
        // }
        window?.zhuge?.track(key, params);
      } catch (err) {
        console.log(`诸葛埋点异常:${JSON.stringify(err)}`);
      }
    };
  },
};

// this.zhugePoint('macc-help-文档中心-模块统计', {
//   userid: "",//用户id
//   lv01: "",//一级目录、模块
//   lv02: "",//二级目录
//   lv03: "",//三级目录
// })
// this.zhugePoint('macc-help-文档中心-文章统计', {
//   userid: "",//用户id
//   articleid: "",//文档id
//   articleTitle: "",//文档title
// })
// this.zhugePoint('macc-help-文档中心-用户统计', {
//   userid: "",//用户id
//   enter:"",//进入时间
//   leave:"",//离开时间
//   count:""//阅读篇数
// })